<script lang="ts" setup>
import SectionTitle from '@/components/Title/SectionTitle.vue'
import type { IEvent } from '@/utils/types/Event'
const props = defineProps({
  event: {
    type: Object as PropType<IEvent>,
    default: {}
  }
})

const faqs = [
  {
    title: '若所報名之活動(包含課程或講座)未達舉辦之門檻，後續會如何處理?',
    text: '若未達活動舉辦之門檻或因其他可歸責本公司之因素而無法舉辦活動，本公司將會於活動日前3個工作天內通知您活動延期日期或進行退款手續。<br>e.g. 若活動日為1月6日，則將於1月3日通知，本公司將主動聯繫您活動延期日期或通知進行退款手續。 工作天為除了星期六、星期日以及國定假日之外的上班日。'
  },
  {
    title: '如遇天災等不可抗力之因素，後續將如何處理?',
    text: '如因天災等不可抗力之因素，本公司將主動聯繫活動延期日期或通知進行退款手續。'
  },
  {
    title: '報名活動後，可以取消參與活動嗎?',
    text: '如因您個人因素無法前來參與活動，您至遲須於以下所載之取消參與活動之期限內於本公司指定之網址申請取消參與活動及退款(如有付費)，後續系統將進行退款手續(如有付費)。<br> 免費參與活動：活動前 1 個工作天<br> 付費參與活動：活動前 5 個工作天<br>ee.g. 若為付費活動，活動日為1月6日，則請於最後期限1月1日前線上申請取消參與活動。工作天為除了星期六、星期日以及國定假日之外的平日。'
  },
  {
    title: '若未於活動日 5 個工作天前申請取消參與活動， 如臨時有事不克出席，可以怎麼處理?',
    text: '如因臨時狀況不克出席，建議您於活動日前將活動名額轉讓，同時請務必告知我們代理參與活動者的姓名及聯絡資訊，以利為代理者進行活動報到手續，您應獲得代理參與活動者之同意，您有權將其個人資料提供予本公司。'
  },
  {
    title: '報名活動後是否可以替換其他活動的場次? ',
    text: '因每場活動為各別獨立的活動，故無法更換其他活動場次。若於取消活動期限內，請您於本公司指定之網址申請取消參加活動及退款(如有付費)，後續系統將進行退款手續(如有付費)。 若於活動開始日前，則可將活動名額轉讓，請您務必告知本公司代理參與活動者的姓名及聯絡資訊，以利為代理者進行活動報到手續，您應獲得代理參與活動者之同意，您有權將其個人資料提供予本公司。'
  },
  {
    title: '可以一次報名多場活動嗎？',
    text: '同一筆訂單可報名多場同場次之名額（名額限制依照該次活動為主），若為不同場次活動，需分成不同訂單下訂。如需進行退款，將以訂單為單位處理，須整筆訂單申請退款，恕無法單獨退款其中一場活動。<br>e.g. 活動 A 有 1 個場次、2種名額資格(早鳥資格、一般資格)，該場次的整體名額數量上限4 位，您於該張訂單最多可報名 4 位名額(早鳥資格+一般資格)。此外，該場次一但訂單成立，就不能再報名該場次。'
  },
  {
    title: '活動是否可以攜伴或攜帶兒童、寵物參加?',
    text: '是否可以攜伴、攜帶兒童或寵物參加，請依活動說明內容為準。如有不確定之處，歡迎聯絡客服單位確認。未報名者請勿逗留於教學區內，以維護活動品質。'
  }
]
</script>

<template>
  <div class="events-faq">
    <div class="events-faq__inner">
      <SectionTitle class="events-faq__inner__title">常見問答</SectionTitle>
      <ul class="events-faq__lists">
        <li v-for="faq in faqs">
          <FaqItem :data="faq" />
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.events-faq {
  @include grid(8, 24);
  margin-top: toRem(50);
  margin-bottom: toRem(80);

  @include max-media(990) {
    @include grid(4, 24);
  }

  &__inner {
    grid-column: 2 / span 6;

    @include max-media(990) {
      grid-column: 1 / span 4;
    }
  }

  &__lists {
    padding-top: toRem(28);

    li {
      &:last-child {
        border-bottom: 1px solid $color-gray-line;
      }
    }
  }
}
</style>
